var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldValidationWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_orange",
    d: "M37.293 32.778L22.675 7.459c-.67-1.16-2.344-1.16-3.014 0L5.043 32.778c-.67 1.16.167 2.61 1.507 2.61h29.236c1.339 0 2.177-1.45 1.507-2.61zm-16.275-.744a2.443 2.443 0 110-4.887 2.443 2.443 0 010 4.887zm2.443-8.087a.999.999 0 01-.999.999h-2.889a.999.999 0 01-.999-.999v-8.765c0-.552.447-.999.999-.999h2.889c.552 0 .999.447.999.999v8.765z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldValidationWarning);
export default __webpack_public_path__ + "static/media/fieldValidationWarning.5407cebeedbc39b9d312a777a72f9693.svg";
export { ForwardRef as ReactComponent };